/**
 * Escapes a string such that it can be read/used by a regex
 * @param str The string to escape
 * @returns An escaped version ready for regex consumption
 */
export function escapeRegex(str: string = '') {
  return str.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&')
}
